export const style = {
  avilabilityTopContainer: {
    padding: "2.4rem 2.4rem 1.2rem 2.4rem",
    background: "var(--blue-gray-100)",
    textAlign: "left",
    display: "flex",
    justifyContent: "space-between",
    "& > h4": {
      color: "var(--black-900)",
      fontSize: "2.4rem",
      fontWeight: 500,
    },
  },
  availabilityListingCreateUpdateContainer: {
    display: "flex",
    backgroundColor: "var(--neutral-100)",
  },
  noAvailabilityList: {
    width: "100%",
  },
  availabilityList: {
    width: "55%",
  },
  addNewAvailability: {
    display: "flex",
    "& > button:first-of-type": {
      padding: "0rem 1.5rem",
    },
  },
  closebutton: {
    marginLeft: "1rem",
    borderRadius: "100%",
    backgroundColor: "var(--neutral-100)",
    height: "4rem",
    width: "4rem",
    alignSelf: "center",
  },
  detailedAvailabilityContainer: {
    width: "45%",
  },
};
